import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../../firebase';
import Layout from '../../components/ui/Layout';
import { Container, Spinner, Button } from 'react-bootstrap';
import ProductDetailsByProduct from './ProductDetailsByProduct';
import { slugify } from '../../constants/site';
import { createLogger } from '../../utils/logger';

const logger = createLogger('ProductResolver');

const FIREBASE_ID_PATTERN = /^[a-zA-Z0-9]{20}$/;

export default function ProductResolver() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [resolvedProductId, setResolvedProductId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const resolve = async () => {
      if (!slug) {
        setNotFound(true);
        setLoading(false);
        return;
      }

      try {
        let productId = null;

        if (FIREBASE_ID_PATTERN.test(slug)) {
          const productSnap = await getDoc(doc(db, 'Products', slug));
          if (productSnap.exists()) {
            productId = productSnap.id;
          }
        }

        if (!productId) {
          const productSeoQuery = query(
            collection(db, 'Products'),
            where('seo_name', '==', slug)
          );
          const productSeoSnap = await getDocs(productSeoQuery);
          if (!productSeoSnap.empty) {
            productId = productSeoSnap.docs[0].id;
          }
        }

        if (!productId && slug && !FIREBASE_ID_PATTERN.test(slug)) {
          const productsSnap = await getDocs(query(collection(db, 'Products'), limit(300)));
          const match = productsSnap.docs.find(d => slugify(d.data()?.display_name) === slug);
          if (match) productId = match.id;
        }

        if (productId) {
          setResolvedProductId(productId);
        } else {
          setNotFound(true);
        }
      } catch (err) {
        logger.error('ProductResolver error:', err);
        setNotFound(true);
      }
      setLoading(false);
    };

    resolve();
  }, [slug]);

  if (loading) {
    return (
      <Layout>
        <Container className="mt-4 text-center">
          <Spinner animation="border" />
          <p>Loading...</p>
        </Container>
      </Layout>
    );
  }

  if (notFound || !resolvedProductId) {
    return (
      <Layout>
        <Container className="mt-4 text-center">
          <p>Product not found.</p>
          <Button variant="outline-primary" onClick={() => navigate('/search')}>
            Search Products
          </Button>
        </Container>
      </Layout>
    );
  }

  return <ProductDetailsByProduct productIdProp={resolvedProductId} />;
}
